import multiApiClient from "./base";

export const FbaArticlesApi = {
  // Cron
  startCronJob: (schedule = "0 8 * * *") =>
    Promise.resolve({
      data: { message: "Placeholder: Cron started", schedule },
    }),

  stopCronJob: () =>
    Promise.resolve({ data: { message: "Placeholder: Cron stopped" } }),

  getCronStatus: () =>
    Promise.resolve({
      data: { active: false, expression: "0 8 * * *", status: "not scheduled" },
    }),

  // Recalculate
  recalculate: (sku) =>
    multiApiClient.post(
      `/fba/articles/recalculate/${encodeURIComponent(sku || "all")}`,
    ),

  // Sync fba sellerlogic articles
  sync: (sku) =>
    multiApiClient.post(
      `/fba/articles/sync/${encodeURIComponent(sku || "all")}`,
    ),

  // Export updated prices to sellerlogic
  exportUpdates: (sku = null) =>
    multiApiClient.post(
      "/fba/articles/export-updates",
      null,
      sku ? { params: { sku } } : {},
    ),

  syncLedger: (asin, startTime, endTime) =>
    multiApiClient.post("/fba/articles/sync-ledger", null, {
      params: { asin, start_time: startTime, end_time: endTime },
    }),
};
